import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import { keyframes } from "@emotion/react";
import PageLang from "../../../config/page.languge";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const shake = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-2px); }
  50% { transform: translateX(2px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
`;

const StickyWhatsAppButton: React.FC = () => {
    const language = useSelector((state: RootState) => state.language.language);

    const handleCallClick = () => {
        window.location.href = "tel:18001232211";
    };

    return (
        <Tooltip
            title={`${PageLang?.TollFreeTitle[language]}: ${PageLang?.TollFreeNumber[language]}`}
            arrow
            sx={{
                "& .MuiTooltip-tooltip": {
                    backgroundColor: "white",
                    color: "black",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    fontSize: "14px",
                }
            }}
        >
            <IconButton
                onClick={handleCallClick} 
                sx={{
                    position: "fixed",
                    right: "40px",
                    bottom: "35px",
                    zIndex: 1000,
                    backgroundColor: "#25D366",
                    color: "white",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                    "&:hover": {
                        backgroundColor: "#1DA851",
                    },
                    animation: `${shake} 1.5s infinite ease-in-out`,
                }}
            >
                <CallIcon fontSize="large" />
            </IconButton>
        </Tooltip>
    );
};

export default StickyWhatsAppButton;
